/**
 * UI languages. Codes match the language keys the figure catalogues carry
 * (`Figure.i18n`, see `scripts/build-figures.py`), so "UI language" and
 * "figure language" share one vocabulary instead of two.
 */
export type Lang = 'en' | 'de' | 'fr' | 'es' | 'cs';

/** [code, native name shown in the picker]. `en` first — the fallback. */
export const LANGUAGES: ReadonlyArray<readonly [Lang, string]> = [
  ['en', 'English'],
  ['de', 'Deutsch'],
  ['fr', 'Français'],
  ['es', 'Español'],
  ['cs', 'Čeština'],
];

export const FALLBACK_LANG: Lang = 'en';

export function isLang(value: string): value is Lang {
  return LANGUAGES.some(([code]) => code === value);
}
